/*!
  Atom, by Koding Themes
  accessibility.js
  https://kodingthemes.com
*/

function getFocusableElements(container) {
   return Array.from(container.querySelectorAll("summary, a[href], button:enabled, fieldset, [tabindex]:not([tabindex^='-']), [draggable], area, select, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"));
}
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
   var elements = getFocusableElements(container);
   console.log('elements', elements);
   var first = elements[0];
   var last = elements[elements.length - 1];
   removeTrapFocus();
   trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
   };
   trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
   };
   trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
         event.preventDefault();
         first.focus();
      }
      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
         event.preventDefault();
         last.focus();
      }
   };
   document.addEventListener('focusout', trapFocusHandlers.focusout);
   document.addEventListener('focusin', trapFocusHandlers.focusin);
   elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
   document.removeEventListener('focusin', trapFocusHandlers.focusin);
   document.removeEventListener('focusout', trapFocusHandlers.focusout);
   document.removeEventListener('keydown', trapFocusHandlers.keydown);
   if (elementToFocus) elementToFocus.focus();
}
//Accessibility helpers
document.addEventListener("DOMContentLoaded", function() {
   //unpack all node elements at once using rest and secure target href links
   [...document.querySelectorAll("a[target=_blank]")].forEach(function(item) {
      item.setAttribute("rel", "noopener noreferrer")
   });
   document.querySelectorAll('.ss-list').forEach(function(select) {
      select.setAttribute('aria-label', 'choose-option');
   });
   //Selectors
   const sidebar = document.querySelectorAll(".js-menu-toggle"),
      panel = document.querySelector(".js-mini-cart-contents"),
      addToCartBtn = document.querySelector('.add-to-cart-button'),
      mainMenu = document.querySelector('.js-menu-toggle-home');

   var cartSummary = document.querySelector(".mini-cart-recommendations");
   if (cartSummary != null) {
      var cartBtn = cartSummary.querySelector(".mini-container");
      var n = cartBtn.querySelector(".view-cart-btn").length;
      var span = cartSummary.querySelector(".tax-note");
      span.addEventListener("focusout", function(e) {
         document.querySelector('body').classList.remove('show-sidebar');
         mainMenu.focus();
      });
   }
   //if cart icon is focused
   if (sidebar != null) {
      sidebar.forEach(function(item, index) {
         item.addEventListener('click', function(e) {
            document.querySelector('aside.sidebar').setAttribute('tabindex', 0);
            document.querySelector('aside.sidebar').focus();
         });
      });
   }
   //move focus to cart drawer
   if (addToCartBtn != null) {
      addToCartBtn.addEventListener('click', function(e) {
         document.querySelector("aside.sidebar").focus;
      });
   }
});
document.addEventListener("keydown", function(event) {
   var activeElement = document.activeElement;
   //click on the warranty product
   if (event.key === "Enter") {
      if (document.querySelector('#warrantyProduct') != null) {
         var warrantyProduct = document.querySelector('#warrantyProduct');
         var productWarrantyBtn = document.querySelector('.product-warranty-btn');
         var isFocused = (document.activeElement === productWarrantyBtn);
         if (isFocused) {
            warrantyProduct.click();
         }
      }
   }
   //click on the upsell product
   if (event.key === "Enter") {
      if (document.querySelectorAll('input[name="upsellProduct[]"]') != null) {
         var upsells = document.querySelectorAll('input[name="upsellProduct[]"]');
         upsells.forEach(function(item, index) {
            var upsellProduct = item;
            var productUpsellBtn = item.closest('.product-upsell-btn-wrp').querySelector('.product-upsell-btn');
            var isFocused = (document.activeElement === productUpsellBtn);
            if (isFocused) {
               upsellProduct.click();
            }
         });
      }
   }
   //show product details on button enter
   if (event.key === "Enter") {
      document.querySelectorAll('.product-overview__feature-btn').forEach(function(self) {
         var isFocused = (document.activeElement === self);
         // console.log(isFocused);
         if (isFocused) {
            document.querySelector('.product-features').classList.toggle("product-features--show");
            document.querySelector('.product-features').classList.toggle('active');
         }
      });
   }

   if (event.shiftKey && event.key === "Tab") {
      if (document.querySelectorAll('#cart').length > 0) {
         document.querySelectorAll('#page-cart-inner #cart-fieldset .cart-items>.line-item').forEach(function(selfClass) {
            var doc1 = selfClass.querySelector('.remove-lines');
            var doc2 = document.activeElement;
            if (doc1 == doc2) {
               event.preventDefault();
               selfClass.querySelector('.line-image a').focus();
            }
         });
      } else {
         document.querySelectorAll('#cart-fieldset .cart-items>.line-item').forEach(function(selfClass) {
            var doc1 = selfClass.querySelector('.remove-lines');
            var doc2 = document.activeElement;
            if (doc1 == doc2) {
               event.preventDefault();
               selfClass.querySelector('.line-image a').focus();
            }
         });
      }
   }
   if (event.key === "Tab" && !(event.shiftKey)) {
      if (document.querySelectorAll('#product').length > 0) {
         var doc1 = document.activeElement;
         var doc2 = document.querySelector('.featured-products>.collection-toggle:last-child .add-to-cart-button');
         if (doc1 == doc2) {
            event.preventDefault();
            document.querySelector('.main-featured-products .glider-prev').focus();
         }
         var doc3 = document.querySelector('.main-featured-products .glider-prev');
         if (doc1 == doc3) {
            event.preventDefault();
            document.querySelector('.main-featured-products .glider-next').focus();
         }
         var doc4 = document.querySelector('.section-product-tabs .nav-tabs .nav-item:last-child .nav-link');
         if (doc1 == doc4) {
            if (document.querySelector('.product-recomendations-section .controls-rec .glider-prev')) {
               event.preventDefault();
               document.querySelector('.product-recomendations-section .controls-rec .glider-prev').focus();
            }
         }
         var doc5 = document.querySelector('.product-recomendations-section .controls-rec .glider-prev');
         if (doc1 == doc5) {
            if (document.querySelector('.product-recomendations-section .controls-rec .glider-next')) {
               event.preventDefault();
               document.querySelector('.product-recomendations-section .controls-rec .glider-next').focus();
            }
         }
         var doc6 = document.querySelector('.product-recomendations-section .controls-rec .glider-next');
         if (doc1 == doc6) {
            if (document.querySelector('#product_recomendation_body .rec-products:first-child .product-details-card a')) {
               event.preventDefault();
               document.querySelector('#product_recomendation_body .rec-products:first-child .product-details-card a').focus();
            }
         }
         var doc6 = document.querySelector('#product_recomendation_body .rec-products:last-child .product-thumb');
         if (doc1 == doc6) {
            if (document.querySelector('.recently-viewed-section .controls .glider-prev')) {
               event.preventDefault();
               document.querySelector('.recently-viewed-section .controls .glider-prev').focus();
            }
         }
         var doc7 = document.querySelector('.recently-viewed-section .controls .glider-prev');
         if (doc1 == doc7) {
            if (document.querySelector('.recently-viewed-section .controls .glider-next')) {
               event.preventDefault();
               document.querySelector('.recently-viewed-section .controls .glider-next').focus();
            }
         }
         var doc8 = document.querySelector('.recently-viewed-section .controls .glider-prev');
         if (doc1 == doc8) {
            if (document.querySelector('.recently-viewed-section .controls .glider-next')) {
               event.preventDefault();
               document.querySelector('.recently-viewed-section .controls .glider-next').focus();
            }
         }
         var doc9 = document.querySelector('.recently-viewed-section .controls .glider-next');
         if (doc1 == doc9) {
            if (document.querySelector('.recently_viewed_products2>div:first-child .product-details-card a')) {
               event.preventDefault();
               document.querySelector('.recently_viewed_products2>div:first-child .product-details-card a').focus();
            }
         }
         var doc10 = document.querySelector('.recently_viewed_products2>div:last-child .product-thumb');
         if (doc1 == doc10) {
            if (document.querySelector('.footer-top #accordion .links-list .footer-menu:first-child a')) {
               event.preventDefault();
               document.querySelector('.footer-top #accordion .links-list .footer-menu:first-child a').focus();
            }
         }
         // var doc11 = document.querySelector('.breadcrumb-item a.active'); //document.querySelector('#MainContent');
         // if (doc1 == doc11) {
         //     if (document.querySelector('.product-medaia-slider-controls .glider-prev')) {
         //         event.preventDefault();
         //         document.querySelector('.product-medaia-slider-controls .glider-prev').focus();
         //     } else if (document.querySelector('.product-images .slides div a')) {
         //         event.preventDefault();
         //         document.querySelector('.product-images .slides div a').focus();
         //     }
         // }
         var doc11 = document.querySelector('#MainContent');
         if (doc1 == doc11) {
            if (document.querySelector('.product-medaia-slider-controls .glider-prev')) {
               event.preventDefault();
               document.querySelector('.product-medaia-slider-controls .glider-prev').focus();
            } else if (document.querySelector('.product-images .slides div a')) {
               event.preventDefault();
               document.querySelector('.product-images .slides div a').focus();
            }
         }
         var doc12 = document.querySelector('.product-medaia-slider-controls .glider-prev');
         if (doc1 == doc12) {
            if (document.querySelector('.js-slides .tns-slide-active a')) {
               event.preventDefault();
               document.querySelector('.js-slides .tns-slide-active a').focus();
            }
         }
         var doc13 = document.querySelector('.js-slides .tns-slide-active a');
         if (doc1 == doc13) {
            if (document.querySelector('.product-medaia-slider-controls .glider-next')) {
               event.preventDefault();
               document.querySelector('.product-medaia-slider-controls .glider-next').focus();
            }
         }
         var doc14 = document.querySelector('.product-medaia-slider-controls .glider-next');
         if (doc1 == doc14) {
            if (document.querySelector('#controls-thumbnails .glider-prev') && document.querySelector('#controls-thumbnails').style.display != 'none') {
               event.preventDefault();
               document.querySelector('#controls-thumbnails .glider-prev').focus();
            } else if (document.querySelector('.product-thumbnails > a.tns-slide-active')) {
               event.preventDefault();
               document.querySelectorAll('.product-thumbnails > a.tns-slide-active')[0].focus();
            } else if (document.querySelector('.single-product-details > a')) {
               event.preventDefault();
               document.querySelector('.single-product-details > a').focus();
            } else if (document.querySelector('.product-vendor a')) {
               event.preventDefault();
               document.querySelector('.product-vendor a').focus();
            }
         }
         var doc15 = document.querySelector('#controls-thumbnails .glider-prev');
         if (doc1 == doc15) {
            if (document.querySelector('.product-thumbnails > a.tns-slide-active')) {
               event.preventDefault();
               document.querySelector('.product-thumbnails > a.tns-slide-active').focus();
            }
         }
         var docAll = document.querySelectorAll('.product-thumbnails > a.tns-slide-active');
         var doc16 = document.querySelectorAll('.product-thumbnails > a.tns-slide-active')[docAll.length - 1];
         if (doc1 == doc16) {
            if (document.querySelector('#controls-thumbnails .glider-next') && document.querySelector('#controls-thumbnails').style.display != 'none') {
               event.preventDefault();
               document.querySelector('#controls-thumbnails .glider-next').focus();
            } else if (document.querySelector('.single-product-details a')) {
               event.preventDefault();
               document.querySelector('.single-product-details a').focus();
            }
         }
         var doc17 = document.querySelector('#controls-thumbnails .glider-next');
         if (doc1 == doc17) {
            if (document.querySelector('.single-product-details > a')) {
               event.preventDefault();
               document.querySelector('.single-product-details > a').focus();
            }
         }
      }
      if (document.querySelectorAll('#cart').length > 0) {
         var doc1 = document.querySelector('.navbar-nav.main-menu>.menu-item:last-child>.nav-link');
         var doc2 = document.activeElement;
         if (doc1 == doc2) {
            event.preventDefault();
            document.querySelector('#page-cart-inner #cart-fieldset .cart-items>.line-item:first-child .line-image a').focus();
         }
         document.querySelectorAll('#page-cart-inner #cart-fieldset .cart-items>.line-item').forEach(function(selfClass, index) {
            var doc1 = selfClass.querySelector('.js-quantity-button.plus');
            if (doc1 == doc2) {
               if (document.querySelector('#page-cart-inner #cart-fieldset .cart-items>.line-item:nth-child(' + (index + 2) + ') .line-image a')) {
                  event.preventDefault();
                  document.querySelector('#page-cart-inner #cart-fieldset .cart-items>.line-item:nth-child(' + (index + 2) + ') .line-image a').focus();
               }
            }
         })
      } else {
        /* var doc1 = document.activeElement;
         var doc2 = document.querySelector('.sidebar');
         if (doc1 == doc2) {
            document.querySelector('#cart-fieldset .cart-items>.line-item:first-child .line-image a').focus();
         }
         document.querySelectorAll('#cart-fieldset .cart-items>.line-item').forEach(function(selfClass, index) {
            var doc2 = selfClass.querySelector('.js-quantity-button.plus');
            if (doc1 == doc2) {
               if (document.querySelector('#cart-fieldset .cart-items>.line-item:nth-child(' + (index + 2) + ') .line-image a')) {
                  event.preventDefault();
                  document.querySelector('#cart-fieldset .cart-items>.line-item:nth-child(' + (index + 2) + ') .line-image a').focus();
               }
            }
         }) */
      }
   }
});
// Accordion functionality js
if (document.querySelectorAll('.faq-item-wrapper .faq-item') != null) {
   var titles = document.querySelectorAll('.faq-item-wrapper .faq-item');
   titles.forEach(function(item, index) {
      item.onclick = function() {
         var content = item.closest('.faq-item-wrapper').querySelector('.faq-item-content');
         if (content.classList.contains('hidden')) {
            content.classList.remove('hidden');
         } else {
            content.classList.add('hidden');
         }
      }
   });
}
// Accordion accesibility js
if (document.querySelectorAll('.faq-item-wrapper') != null) {
   document.addEventListener("keydown", function(event) {
      var activeElement = document.activeElement;
      if (event.key === "Enter") {
         document.querySelectorAll('.faq-item-wrapper').forEach(function(self, index) {
            var item = self.querySelector('.faq-item');
            var itemContent = self.querySelector('.faq-item-content');
            if (activeElement === self) {
               if (itemContent.classList.contains('hidden')) {
                  itemContent.classList.remove('hidden');
               } else {
                  itemContent.classList.add('hidden');
               }
            }
         });
      }
   });
}
// Atom accessibility
// active the page first element
window.addEventListener("load", (event) => {
   var skipContent = document.querySelector(".skip-to-content-link");
   if (skipContent != null) {
      document.body.setAttribute('tabindex', -1);
      skipContent.focus();
      skipContent.style.opacity = 0;
      skipContent.style.visibility = 'hidden';
   }
});
document.addEventListener("keydown", function(event) {
   var activeElement = document.activeElement;
   setTimeout(function() {
      var skipContent = document.querySelector(".skip-to-content-link");
      var logo = document.querySelector('.shop-link');
      var searchBox = document.querySelector('.top-header .input-group');
      var sidebarCartIcon = document.querySelector(".js-menu-toggle");
      var searchLinkIcon = document.querySelector(".js-search-modal-link");
      var searchModalClose = document.querySelector(".search-modal-close");
      var cartClose = document.querySelector(".js-close-cart");
      var mainMenu = document.querySelector('.js-menu-toggle-home');
      var openMenu = mainMenu.querySelector('.open-menu-hamburger');
      var closeMenu = mainMenu.querySelector('.close-menu-hamburger');
      var prentItemList = document.querySelectorAll('.sidebar-menu-list-parent li a');
      var menuParentFirstItem = document.querySelector('.sidebar-menu-list-parent li:first-child a');
      var menuToggles = document.querySelectorAll('.sidebar-menu-list-parent li .dropdown-toggle');
      var accountMenu = document.querySelector('.main-sidebar .js-account a');
      var socailMediaTop = document.querySelector('.top-header .social-media-grid a');
      var slideShow = document.querySelector('.new-animation-slider');
      var slideShowPrev = document.querySelector('.slide-navigation-item-prev');
      var breadcrumb = document.querySelector('.breadcrumb-item:first-child a');
      var labelsFilter = document.querySelectorAll('.collection-filter-sidebar .form-check-label');

      if (event.key === "Tab" && !(event.shiftKey)) {
         // Next after skip content
         if (activeElement == skipContent && logo != null) {
            logo.focus({
               focusVisible: true
            });
         }
         // Next after logo
         if (activeElement == logo && searchBox != null) {
            searchBox.focus();
         }
         if (activeElement == logo && socailMediaTop != null) {
            socailMediaTop.focus();
         }
         // Next after search icon
         if (activeElement == searchLinkIcon) {
            mainMenu.focus({
               focusVisible: true
            });
         }
         // Next after search modal
         if (activeElement == searchModalClose) {
            document.body.classList.remove('show-search-modal');
            mainMenu.focus({
               focusVisible: true
            });
         }
         // close search modal
         var searchPageLink = document.querySelector(".search-results li:last-child a.js-search-result-page-link");
         var searchPageLinks = document.querySelectorAll(".search-results li:last-child a.js-search-result-page-link");
         if (searchPageLinks != null) {
            searchPageLinks.forEach(function(searchPageLink, index) {
               if (activeElement == searchPageLink) {
                  var searchResult = activeElement.closest('.search-results');
                  searchResult.innerHTML = '';
                  searchResult.style.display = 'none';
                  if (document.body.classList.contains('show-search-modal')) {
                     document.body.classList.remove('show-search-modal');
                     mainMenu.focus({
                        focusVisible: true
                     });
                  }
               }
            });
         }
         // Next after open menu
         var tabindexedItems = document.querySelectorAll('.sidebar-mega-menu-list li a[tabindex="0"]');
         if (tabindexedItems != null) {
            var tabindexedLastItem = tabindexedItems[tabindexedItems.length - 1];
            if (activeElement == tabindexedLastItem) {
               var AllMenuItems = document.querySelectorAll('.sidebar-mega-menu-list li a');
               document.body.classList.remove('show-sidebar-main');
               document.body.classList.remove('active');
               if (AllMenuItems != null) {
                  AllMenuItems.forEach(function(item, index) {
                     item.setAttribute('tabindex', -1);
                     var isNextCol = item.dataset.nextcolumn;
                     if (isNextCol != undefined) {
                        var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                        goNextCol.setAttribute('tabindex', -1);
                     }
                  });
               }
            }
         }
         // Next after account menu
         if (slideShow != null && accountMenu != null) {
            if (activeElement == accountMenu) {
               slideShow.focus();
            }
         }
         if (breadcrumb != null && accountMenu != null) {
            if (activeElement == accountMenu) {
               breadcrumb.focus();
            }
         }
         // Next after slide section
         if (slideShow != null && slideShowPrev != null) {
            if (activeElement == slideShow) {
               slideShowPrev.focus();
            }
         }
         if (labelsFilter != null) {
            labelsFilter.forEach(function(lable, index) {
               if (activeElement == lable) {
                  TweenMax.to(window, 1, {
                     scrollTo: lable
                  });
               }
            });
         }
         // for product page
         var breadcrumbLast = document.querySelector('.breadcrumb-item:last-child a');
         //var productImage = document.querySelector('.product-media-desktop-only .focus-inset:first-child');
         var productDetails = document.querySelector('.single-product-details form a.focus-inset');
         if (breadcrumbLast != null && productDetails != null) {
            if (activeElement == breadcrumbLast) {
               productDetails.focus();
            }
         }
      }
      if (event.key === "Enter") {
         // code for search modal
         if (activeElement == searchLinkIcon) {
            var modal = searchLinkIcon.closest('.header-search-nav');
            var modalSearch = modal.querySelector('.js-search-input');
            if (modalSearch != null) {
               modalSearch.focus();
            }
         }
         if (activeElement == searchModalClose) {
            document.body.classList.remove('show-search-modal');
            mainMenu.focus({
               focusVisible: true
            });
         }

         if (activeElement == cartClose) {
            cartClose.click();
           setTimeout(function(){
            searchLinkIcon.focus({
               focusVisible: true
            });
           },100);
         }

         // code for collection filter
         if (labelsFilter != null) {
            labelsFilter.forEach(function(lable, index) {
               if (activeElement == lable) {
                  lable.click();
               }
            });
         }
         // Code for sidebar menu

         if (activeElement == mainMenu) {
           setTimeout(function(){
             if (openMenu != null && document.body.classList.contains('show-sidebar-main') == false) {
               document.body.classList.add('show-sidebar-main');
               document.body.classList.add('active');
               if (prentItemList != null) {
                  prentItemList.forEach(function(item, index) {
                     item.setAttribute('tabindex', 0);
                     var isNextCol = item.dataset.nextcolumn;
                     if (isNextCol != undefined) {
                        var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                        goNextCol.setAttribute('tabindex', 0);
                        console.log(isNextCol);
                     }
                  });

                  menuParentFirstItem.focus({
                     focusVisible: true
                  });

               }
            } else if (closeMenu != null && document.body.classList.contains('show-sidebar-main')) {
               document.body.classList.remove('show-sidebar-main');
               document.body.classList.remove('active');
               if (prentItemList != null) {
                  prentItemList.forEach(function(item, index) {
                     item.setAttribute('tabindex', -1);
                     var isNextCol = item.dataset.nextcolumn;
                     if (isNextCol != undefined) {
                        var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                        goNextCol.setAttribute('tabindex', -1);
                        console.log(isNextCol);
                     }
                  });
               }
            }
           },100);
         }
        setTimeout(function(){
         var toggleMenuItems = document.querySelectorAll('.sidebar-mega-menu-list li .dropdown-toggle');
         toggleMenuItems.forEach(function(item, index) {
            var nextCol = item.closest('li').querySelector('a').dataset.nextcolumn;
            if (nextCol != null) {
               // unset
               var enableCol = document.querySelector('.' + nextCol);
               enableCol.closest('.sidebar-menu-columns').classList.remove('.active-sidebar-nav-column');
               enableCol.closest('.sidebar-menu-columns').style.width = '0';
               enableCol.style.display = 'none';
               var list = enableCol.querySelectorAll('li');
               if (list != null) {
                  list.forEach(function(item, index) {
                     //item.style.opacity = 0;
                     item.querySelector('a').setAttribute('tabindex', -1);
                     var goNextCol = item.querySelector('.dropdown-toggle');
                     if (goNextCol != null) {
                        goNextCol.setAttribute('tabindex', -1);
                     }
                  });
               }
               // unset
            }
         });
         toggleMenuItems.forEach(function(item, index) {
            var nextCol = item.closest('li').querySelector('a').dataset.nextcolumn;
            if (nextCol != null) {
               if (activeElement == item) {
                  // toggle dropdown active
                  setTimeout(function() {
                     var currentTabindexList = item.closest('.sidebar-mega-menu-list').querySelectorAll('[tabindex="0"]');
                     if (currentTabindexList != null) {
                        var tabindexStatus = 0;
                        currentTabindexList.forEach(function(tabindexItem, i) {
                           if (tabindexStatus == 0) {
                              if (tabindexItem == item) {
                                 tabindexStatus = -1;
                              }
                           } else {
                              tabindexItem.setAttribute('tabindex', -1);
                           }
                        });
                        console.log('active toggle1', currentTabindexList);
                     }
                  }, 100);
                  // Enable current col when this is child col
                  var currentStep = item.closest('.sidebar-menu-columns').dataset.currentstep;
                  if (currentStep == 'child') {
                     var enableCol = item.closest('ul');
                     enableCol.closest('.sidebar-menu-columns').classList.add('.active-sidebar-nav-column');
                     enableCol.closest('.sidebar-menu-columns').style.width = '100%';
                     enableCol.style.display = 'block';
                     var list = enableCol.querySelectorAll('li');
                     if (list != null) {
                        list.forEach(function(item, index) {
                           //item.style.opacity = 1;
                           item.querySelector('a').setAttribute('tabindex', 0);
                           var goNextCol = item.querySelector('.dropdown-toggle');
                           if (goNextCol != null) {
                              goNextCol.setAttribute('tabindex', 0);
                           }
                           if (index == 0) {
                              item.querySelector('a').focus();
                           }
                        });
                     }
                  }
                  // Enable next col
                  var enableCol = document.querySelector('.' + nextCol);
                  enableCol.closest('.sidebar-menu-columns').classList.add('.active-sidebar-nav-column');
                  enableCol.closest('.sidebar-menu-columns').style.width = '100%';
                  enableCol.style.display = 'block';
                  var list = enableCol.querySelectorAll('li');
                  if (list != null) {
                     list.forEach(function(item, index) {
                        //item.style.opacity = 1;
                        item.querySelector('a').setAttribute('tabindex', 0);
                        var goNextCol = item.querySelector('.dropdown-toggle');
                        if (goNextCol != null) {
                           goNextCol.setAttribute('tabindex', 0);
                        }
                        if (index == 0) {
                           item.querySelector('a').focus();
                        }
                     });
                  }
               }
            }
         });
         },100);
         // /Code for sidebar menu
         // code for cart drawer
         var addToCartBtn = document.querySelector('.add-to-cart-button')
         if (addToCartBtn != null) {
            console.log('loadedfocus');
            document.querySelector('aside.sidebar').setAttribute('tabindex', 0);
            document.querySelector("aside.sidebar").focus({
               focusVisible: true
            });
         }
         // Code for product input pills
         var radioWraps = document.querySelectorAll('.styled-pills-radio');
         if (radioWraps != null) {
            radioWraps.forEach(function(radioWrap, index) {
               var radios = radioWrap.querySelectorAll('input[type="radio"]');
               if (radios != null) {
                  radios.forEach(function(radio, index) {
                     var inputSelector = activeElement.getAttribute('for');
                     if (activeElement.closest('.styled-pills-radio') != null) {
                        var radioTofocus = activeElement.closest('.styled-pills-radio').querySelector('#' + inputSelector);
                        if (radioTofocus == radio) {
                           radioTofocus.checked = true;
                           radioTofocus.onchange();
                           activeElement.focus();
                        }
                     }
                  });
               }
            });
         }
         // /Code for product input pills
      }
      if (event.key === "Escape"){
        if(document.body.classList.contains('show-sidebar-main')){
            closeMenu.click();
            var allItems = document.querySelectorAll('.sidebar-menu [tabindex="0"]');
            console.log(allItems);
            if(allItems != null){
                allItems.forEach(function(item, index) {
                    item.setAttribute('tabindex', -1);
                });
            }
            mainMenu.focus();
        }
      }
      if (event.shiftKey && event.key === "Tab") {
         // Next after header
         if (activeElement == searchBox && logo != null) {
            logo.focus();
         }
         if (activeElement == socailMediaTop && logo != null) {
            logo.focus();
         }
         // Next after slideshow
         if (slideShow != null && accountMenu != null) {
            if (activeElement == slideShow) {
               accountMenu.focus();
            }
         }
         // breadcrumb to account menu
         if (breadcrumb != null && accountMenu != null) {
            if (activeElement == breadcrumb) {
               accountMenu.focus();
            }
         }
         // filter item access
         var inputSortBy = document.querySelector('.ss-search input[type="search"]');
         var clearFilter = document.querySelector('.filter-form .clear-button');
         if (inputSortBy != null && clearFilter != null) {
            if (activeElement == inputSortBy) {
               TweenMax.to(window, 1, {
                  scrollTo: clearFilter
               });
            }
         }
         if (labelsFilter != null) {
            labelsFilter.forEach(function(lable, index) {
               if (activeElement == lable) {
                  gsap.to(window, {
                     duration: 1,
                     scrollTo: {
                        y: lable,
                        offsetY: 200
                     }
                  });
               }
            });
         }
         // close search modal
         if (searchLinkIcon != null) {
            var modal = searchLinkIcon.closest('.header-search-nav');
            var modalSearchInput = modal.querySelector('.js-search-input');
            if (modalSearchInput != null && activeElement == modalSearchInput) {
               document.body.classList.remove('show-search-modal');
               searchLinkIcon.focus();
            }
         }
         // close sidebar menu
         if (mainMenu == activeElement) {
            searchLinkIcon.focus();
            document.body.classList.remove('show-sidebar-main');
            document.body.classList.remove('active');
            if (prentItemList != null) {
               prentItemList.forEach(function(item, index) {
                  item.setAttribute('tabindex', -1);
                  var isNextCol = item.dataset.nextcolumn;
                  if (isNextCol != undefined) {
                     var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                     goNextCol.setAttribute('tabindex', -1);
                  }
               });
            }
         }
         // menu column to close icon
         var parentListFirstItem = document.querySelector('.sidebar-mega-menu-list li:first-child a[tabindex="0"]');
         if (parentListFirstItem != null) {
            if (activeElement == parentListFirstItem) {
               document.body.classList.remove('show-sidebar-main');
               document.body.classList.remove('active');
               if (prentItemList != null) {
                  prentItemList.forEach(function(item, index) {
                     item.setAttribute('tabindex', -1);
                     var isNextCol = item.dataset.nextcolumn;
                     if (isNextCol != undefined) {
                        var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                        goNextCol.setAttribute('tabindex', -1);
                     }
                  });
               }
               setTimeout(function() {
                  mainMenu.focus();
               }, 100);
            }
         }
         // sidebar menu col close
         var AllListFirstItems = document.querySelectorAll('.sidebar-mega-menu-list li:first-child a[tabindex="0"]');
         if (AllListFirstItems != null) {
            AllListFirstItems.forEach(function(item, index) {
               if (activeElement == item && item.closest('.sidebar-menu-list-parent') == null) {
                  var disableCol = item.closest('ul');
                  console.log(item, disableCol);
                  disableCol.closest('.sidebar-menu-columns').classList.remove('.active-sidebar-nav-column');
                  disableCol.closest('.sidebar-menu-columns').style.width = '0';
                  disableCol.style.display = 'none';
                  var list = disableCol.querySelectorAll('li');
                  if (list != null) {
                     list.forEach(function(item, index) {
                        //item.style.opacity = 0;
                        item.querySelector('a').setAttribute('tabindex', -1);
                        var goNextCol = item.querySelector('.dropdown-toggle');
                        if (goNextCol != null) {
                           goNextCol.setAttribute('tabindex', -1);
                        }
                     });
                  }
                  //
                  var currentColstep = item.closest('.sidebar-menu-columns').dataset.currentstep;
                  if (currentColstep == 'grandchild') {
                     var colLists = document.querySelectorAll('.sidebar-menu-columns-child .sidebar-menu-list-child');
                     colLists.forEach(function(list, index) {
                        if (list.style.display == 'block') {
                           var tabIndexLists = list.querySelectorAll('li a[tabindex="-1"],li span[tabindex="-1"]');
                           tabIndexLists.forEach(function(tabIndexList, index) {
                              tabIndexList.setAttribute('tabindex', 0);
                           });
                        }
                     });
                  }
                  console.log('currentColstep', currentColstep);
                  if (currentColstep == 'child') {
                     var colList = document.querySelector('.sidebar-menu-columns-parent .sidebar-menu-list-parent');
                     var tabIndexLists = colList.querySelectorAll('li a[tabindex="-1"],li span[tabindex="-1"]');
                     console.log('tabIndexLists', tabIndexLists);
                     tabIndexLists.forEach(function(tabIndexList, index) {
                        tabIndexList.setAttribute('tabindex', 0);
                     });
                  }
                  //
               }
            });
         }
      }
      // to scrollintoview sections which have gsap animations
      if (document.querySelectorAll('.animation-applied-element') != null) {
         gsap.set('.animation-applied-element', {
            clearProps: true
         });
         if (activeElement.closest('.animation-applied-element')) {
            setTimeout(function() {
               var active = document.activeElement;
               var section = active.closest('.animation-applied-element');
               if(active.closest('body#article') == null){
                 gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                       y: section,
                    }
                 });
               }
            }, 10);
         }
      }
      // to scroll intoview product image
      setTimeout(function() {
         var active = document.activeElement;
         if (active.closest('#product-image')) {
            if (active.closest('.single-product-image')) {
               active = active.closest('.single-product-image');
            } else if (active.closest('.model-container')) {
               active = active.closest('.model-container');
            } else if (active.closest('.external-video-container')) {
               active = active.closest('.external-video-container');
            } else if (active.closest('.video-container')) {
               active = active.closest('.video-container');
            }
            gsap.to(window, {
               duration: 1,
               scrollTo: {
                  y: active,
               }
            });
         }
      }, 5);
      console.log('activeElement',activeElement);

     //product sizeguide drawer
      var sizeGuideBtn = document.querySelector('.js-size-guide-btn');
      var sizeGuideClose = document.querySelector('.js-close-size-guide');
      var arryOfA = document.querySelectorAll('.size-guide-contents a');
      var lastElement = arryOfA[arryOfA.length - 1];

      if (!event.shiftKey && event.key === "Tab") {
         if(lastElement != null){
           if(activeElement == lastElement){
             document.body.classList.remove('show-size-guide');
             sizeGuideBtn.focus();
           }
         }
      }

     if (event.key === "Enter") {
       if(sizeGuideBtn != null && sizeGuideClose != null){
         if(activeElement == sizeGuideBtn){
           sizeGuideClose.focus();
         }
         if(activeElement == sizeGuideClose){
           document.body.classList.remove('show-size-guide');
           sizeGuideBtn.focus();
         }
       }
     }
     //sizeguide accordion accessibility
     var accItems = document.querySelectorAll('.size-guide-content-accordion .product-accordion-item .faq-title');
     if(accItems != null){
        if (event.key === "Enter") {
          accItems.forEach(function(item,index){
              if(activeElement == item){
                   activeElement.focus();
                  item.classList.toggle('active');
                  item.closest('.product-accordion-item').querySelector('.faq-content').classList.toggle('active');
               }
          });
        }
     }
   }, 5);
});
// /Atom accessibility
